 const Data=[
    {
        id:1,
        question:'What is UTOPIA42?',
        answer:'Utopia42 is a decentralized <a href="https://en.wikipedia.org/wiki/Multiverse" target="_blank">Multiverse</a>. Different organizations, communities and projects can deploy their own metaverse and start to build their own world.'
    },
    {
        id:2,
        question:'What is a Multiverse?',
        answer:'Multiverse to Metaverse is like Ethereum to Bitcoin networks. On a Multiverse platform everyone can run his/her own verse and start to build a metaverse.'
    }, {
        id:3,
        question:'What blockchain is UTOPIA42 built on?',
        answer:'Utopia42 is launched on Polygon as the first blockchain. But the protocol is multichain and we will use the Muon network to make other blockchain currencies available shortly.'
    }, {
        id:4,
        question:'What’s the difference between Utopia42 and other Metaverses?',
        answer:'<ul><li>Utopia42 is a Multiverse. Every project and community can run its own Metaverse and start to build its own world. The sky is NOT the limit on Utopia42. There will be a lot of worlds, skys, etc.</li><li>One of the goals is to connect real world applications to Utopia42. It is not just a platform for entertainment. We invite the different projects to run Universities, Virtual Offices, Museums, Libraries,  on Utopia42 and try to offer their services to everyone on a borderless and decentralized platform.</li></ul>'
    }, {
        id:5,
        question:'How can individuals and organizations get their own Metaverse?',
        answer:`Under<a href="https://dapp.utopia42.club/CreateVerse"> Utopia42's dApp</a> you can create your own 'Verse. If you are looking for a customized solution and help building, please <a href="https://forms.gle/xnHYDNQ2R3HwdVAZ8">Apply here</a>.`
    },
    {
        id:6,
        question:'How can one get the Utopia42 token?',
        answer:'The tokens and NFT marketplaces are under development and will be launched soon.'
    },
    {
        id:7,
        question:'Who is managing Utopia42?',
        answer:'Utopia42 is a decentralized autonomous organization (DAO). There is a governance token and a voting <a href="http://www.vote.utopia42.club" target="blank">platform</a> the community members and developers can create proposals and vote to define the future roadmap of the project.'
    },
    {
        id:8,
        question:'Is there an official socials group?',
        answer:`We have an official <a href="https://t.me/Utopia42_Club" target="_blank">telegram</a> group, with other media presence on <a href="https://discord.gg/TphaKUZzHx" target="_blank">discord</a>, <a href="https://www.instagram.com/utopia42.club/" target="_blank">instagram</a> and <a href="https://twitter.com/utopia42c" target="_blank">twitter</a>.`
    },
    {
        id:9,
        question:'What is Utopia42 Citizen ID?',
        answer:`Utopia42 is a world of metaverse. Each user can mint a Soulbound NFT as a Citizen ID and connect it to BrightID to prove their uniqueness. Utopia42 will have a community of unique people in the world.<p> Utopia42 uses the <a href="https://www.brightid.org/" target="_blank">BrightID</a> protocol to allow people to prove to applications that they aren’t using multiple accounts. It solves the unique identity problem through the creation and analysis of a social graph. BrightID is self-issued and verified by close friends or relatives. Personal data is not shared with a central organization. The BrightID <a href="https://www.brightid.org/whitepaper" target="_blank">whitepaper</a> is available for more technical details.</p>`
    },
    {
        id:10,
        question:'What plugins are used for Utopia42?',
        answer:`Utopia 42 is under growth and development. All plugins and relevant technologies are listed in the Utopia42 github <a href="https://github.com/Utopia42-club" target="_blank">repository</a>. `
    },
]

export default Data
